<template>
  <div v-loading="coursePlanLoading" class="course-plan-box">
    <div class="user-defined-table3">
      <div class="user-defined-tr">
        <div v-for="(items,index) in dates" :key="index" class="user-defined-td user-defined-th">
          <template v-if="index === 0">
            <div class="header-div">
              <div class="header-col1">时间段</div>
              <div class="header-col2">星期</div>
              <div class="header-line2"></div>
            </div>
          </template>
          <template v-else>
            <div>{{ items.week }}</div>
            <div>{{ items.date }}</div>
          </template>
        </div>
      </div>
      <div v-for="(time,tindex) in timeList" v-if="timeList[tindex + 1]" :key="tindex" class="user-defined-tr">
        <div v-for="(items,index) in dates" :key="index" class="user-defined-td">
          <div v-if="index === 0" class="course-all-list">
            {{ time }} ~ {{ timeList[tindex + 1] }}
          </div>
          <div v-else class="course-all-list">
            <el-button type="text" :disabled="getDisable(items.date,time,timeList[tindex + 1])" :style="getStyle(items.date,time,timeList[tindex + 1])" @click="siteShow(items.date,time,timeList[tindex + 1])">
              {{ lessonList[items.date+'_'+time+'_'+timeList[tindex + 1]]&&lessonList[items.date+'_'+time+'_'+timeList[tindex + 1]].site_name?lessonList[items.date+'_'+time+'_'+timeList[tindex + 1]].site_name:'选择上课门店' }}
            </el-button>
          </div>

        </div>

      </div>
    </div>
    <!--门店列表-->
    <el-dialog title="门店列表" :visible.sync="dialogSitesVisible" width="600px" top="15vh" :append-to-body="true" @close="siteclose">
      <el-table ref="siteSingleTable" highlight-current-row :data="siteList" max-height="50vh" :row-class-name="tableRowClassName" @current-change="handleCurrentChange">
        <el-table-column property="name" label="门店名称"></el-table-column>
        <el-table-column width="150" align="center" prop="type_name" label="门店类型"> </el-table-column>
        <el-table-column width="150" align="center" prop="open_status" label="是否营业">
          <template slot-scope="{ row }">
            {{ row.open_status === 1 ? '休息' : '营业' }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="selectCancleSite">取消选择</el-button>
        <el-button type="primary" @click="selectSite">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/lesson/lesson' // 和数据交互相关写在api 方便复用
import commonList from '@/utils/commonList'
import coachApi from '@/api/coach/coach' // 和数据交互相关写在api 方便复用

export default {
  name: 'LessonSet',
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  props: {
    coachId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogSitesVisible: false,
      api,
      coursePlanLoading: false,
      coachInfo: {},
      dates: [],
      timeList: [],
      lessonList: {},
      siteList: [],
      currentCell: {},
      currentSiteRow: {}

    }
  },
  beforeMount() {
    this.getdates()
  },
  mounted() {
    // this.getCoachInfo()
    this.getTimeList()
    // this.getCoachList()
    this.getDatePlan()
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      // if (this.currentCell) {
      //   const currentKey = this.currentCell.date + '_' + this.currentCell.time + '_' + this.currentCell.end_time
      //   if (this.lessonList[currentKey] && this.lessonList[currentKey].site_id === row.id) {
      //     // return 'success-row'
      //     this.$refs.siteSingleTable.setCurrentRow(row)
      //   }
      // }
      return ''
    },
    getdates() {
      const now = new Date()
      const weekLabels = ['一', '二', '三', '四', '五', '六', '日']
      const dates = [
        {
          field: 'time',
          week: '',
          date: ''
        }
      ]
      for (let i = 0; i <= 13; i++) {
        const date = new Date(now.getTime() + 24 * 60 * 60 * 1000 * i)
        let week = date.getDay()
        week = week === 0 ? 7 : week
        let month = date.getMonth() + 1
        month = month < 10 ? '0' + month : month
        let day = date.getDate()
        day = day < 10 ? '0' + day : day
        dates.push({
          field: 'week' + week,
          week: '周' + weekLabels[week - 1],
          date: date.getFullYear() + '-' + month + '-' + day
        })
      }
      this.$nextTick(() => {
        this.dates = dates
      })
    },
    getDisable(date, srart_time, end_time) {
      if (date === this.dates[1].date) {
        const now = new Date()
        const currentTime = new Date(date + ' ' + srart_time + ':00')
        if (currentTime <= now) {
          // 过了当前时间
          return true
        }
      }
      return false
    },
    getStyle(date, srart_time, end_time) {
      if (date === this.dates[1].date) {
        const now = new Date()
        const currentTime = new Date(date + ' ' + srart_time + ':00')
        if (currentTime <= now) {
          // 过了当前时间
          return 'color:#999'
        }
      }
      if (this.lessonList[date + '_' + srart_time + '_' + end_time]) {
        return ''
      } else {
        return 'color:#666'
      }
    },
    // -------------------
    // 获取时间段
    getTimeList() {
      this.timeList = []
      api.getBusinessTime().then((res) => {
        const start_time = Number(res.data.business_start_time.split(':')[0])
        const end_time = Number(res.data.business_end_time.split(':')[0])
        for (let i = start_time; i <= end_time; i++) {
          if (i < 10) {
            this.timeList.push('0' + i + ':00')
          } else {
            this.timeList.push(i + ':00')
          }
        }
      })
    },
    getDatePlan() {
      this.coursePlanLoading = true
      api.oneList({
        coach_id: this.coachId
      }).then(res => {
        this.lessonList = res.data
        this.coursePlanLoading = false
      }).catch(() => { this.coursePlanLoading = false })
    },
    async siteShow(date, time, end_time) {
      const isbook = await this.isBook(date, time)
      if (isbook) {
        this.$message({
          message: '该时间段已有预约，不可更改',
          type: 'error'
        })
        return
      }
      const _this = this
      coachApi.SiteList({
        coach_id: this.coachId,
        time: time + ' ~ ' + end_time
      }).then(response => {
        this.currentCell = {
          date,
          time,
          end_time
        }
        this.siteList = response.data
        this.dialogSitesVisible = true
        this.$nextTick(() => {
          if (this.currentCell) {
            const currentKey = this.currentCell.date + '_' + this.currentCell.time + '_' + this.currentCell.end_time
            if (this.lessonList[currentKey]) {
              for (const i in this.siteList) {
                if (this.lessonList[currentKey].site_id === this.siteList[i].id) {
                  _this.$refs.siteSingleTable.setCurrentRow(this.siteList[i])
                }
              }
            }
          }
        })
      })
    },
    isBook(date, start_time) {
      return new Promise((resolve, reject) => {
        api.isBook({ date: date, start_time: start_time, coach_id: this.coachId }).then((res) => {
		      resolve(res.data)
        })
      })
    },
    handleCurrentChange(val) {
      this.currentSiteRow = val
    },
    selectSite() {
      const currentKey = this.currentCell.date + '_' + this.currentCell.time + '_' + this.currentCell.end_time
      api.saveLesson({
        date: this.currentCell.date,
        site_id: this.currentSiteRow.id,
        start_time: this.currentCell.time,
        end_time: this.currentCell.end_time,
        coach_id: this.coachId
      })
        .then((res) => {
          this.$message({
            message: '保存成功',
            type: 'success'
          })
          this.lessonList[currentKey] = {
            id: res.data,
            date: this.currentCell.date,
            site_id: this.currentSiteRow.id,
            site_name: this.currentSiteRow.name,
            start_time: this.currentCell.time,
            end_time: this.currentCell.end_time,
            coach_id: this.coachId
          }
          this.dialogSitesVisible = false
          this.siteclose()
        })
    },
    selectCancleSite() {
      const currentKey = this.currentCell.date + '_' + this.currentCell.time + '_' + this.currentCell.end_time
      if (this.lessonList[currentKey]) {
        api.delLesson({
          id: this.lessonList[currentKey].id
        })
          .then((res) => {
            this.$message({
              message: '取消成功',
              type: 'success'
            })
            this.lessonList[currentKey] = null
            this.dialogSitesVisible = false
            this.siteclose()
          })
      }
    },
    siteclose() {
      this.listQuery = {
        page: 1,
        limit: 6,
        order: 'ASC',
        sort: 'order_no'
      }
      this.currentCell = {}
      this.currentSiteRow = null
    }

  }
}
</script>
<style>
.el-table .success-row {
    background: #e8f4ff;
  }
.user-defined-table3{
    width:2157px;
    height:500px;
    /* overflow-y: scroll; */
    display: flex;
    flex-direction: column;
    border-left: 1px solid #dfe6ec;
    border-top: 1px solid #dfe6ec;
  }
  .user-defined-tr{
    display: flex;
  }
  .user-defined-td{
    width:150px;
    padding: 10px;
    color: #606266;
    font-weight: 500;
    font-size: 14px;
    border-right: 1px solid #dfe6ec;
    border-bottom: 1px solid #dfe6ec;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  .user-defined-th{
    font-weight: 600;
  }
  .header-div {
    width:100%;
    position: relative;
  }
  .header-col1 {
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .header-col2 {
    position: absolute;
    right: 0;
    top: 0;
  }
  .header-line2 {
    padding-left: 0;
    width: 1px;
    height: 120px;
    transform: rotate(-67deg); /*这里需要自己调整，根据线的位置*/
    -webkit-transform-origin: top;
    transform-origin: top;
    background-color: #fff;
    border-left:1px solid #e5e5e5;
  }
/deep/ .column-custom {
	padding: 0px !important;
}

 /deep/ .el-table--border .el-table__cell:first-child .cell {
	padding: 0 !important;
}
.el-table::before{
  height:0 !important;
}

.course-plan-box{
  width: 1150px;
  margin:20px auto;
  height:60vh;
  overflow-x: scroll;
  /* overflow-y: scroll; */
}
.is-selected {
    color: #1989FA;
  }
  .course-all-list{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pagination-container{
    padding-bottom:0 !important;
  }

</style>
